import React, { useEffect, useState } from "react";
import style from "./globalstudentgparigorsummary.module.css";
import { Toast, ToastContainer } from "react-bootstrap";
import {
  getOverviewTexts,
  saveOverviewTexts,
  getGpaPercentAverages,
} from "../../../lib/studentcourselessonreport";
import { getColorClass } from "./globalstudentgparigorsummary";

const levelClassMap = {
  Ovr: style.apCell,
  AP: style.apCell,
  HR: style.hrCell,
  CC: style.ccCell,
  EA: style.eaCell,
  RG: style.rgCell,
  OT: style.otCell,
};

export default function GlobalStudentCourseLessonAverageGpaReport({
  studentId,
  isStudent = false,
}) {
  const [data, setData] = useState({});
  const [overview, setOverview] = useState({});
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [allLevels, setAllLevels] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);

  useEffect(() => {
    loadData();
  }, [studentId]);

  const loadData = async () => {
    const gpaData = await getGpaPercentAverages(studentId);
    const overviewRes = await getOverviewTexts(studentId);

    const dataMap = {};
    const levelSet = new Set();
    const departmentSet = new Set();

    gpaData.forEach((item) => {
      const { department, studentId, ...rest } = item;
      if (!dataMap[department]) dataMap[department] = {};

      Object.entries(rest).forEach(([key, value]) => {
        // "Overall" -> "Ovr" çevir, diğerleri direkt kalsın
        const level = key;
        dataMap[department][level] = value ?? 0;
        levelSet.add(level);
      });

      departmentSet.add(department);
    });

    const overviewMap = {};
    overviewRes.forEach((item) => {
      overviewMap[item.type] = item.desc;
    });

    setData(dataMap);
    setOverview(overviewMap);
    //setAllLevels([...levelSet]); // sadece gelen başlıkları göster
    setAllLevels(["Overall", ...[...levelSet].sort().filter((lvl) => lvl !== "Overall")]);
    setAllDepartments([...departmentSet]);
  };

  const handleOverviewChange = (value) => {
    setOverview((prev) => ({ ...prev, caverageTest: value }));
  };

  const handleUpdate = async () => {
    await saveOverviewTexts(studentId, {
      caverageTest: overview.caverageTest || "",
    });
    setShowToast(true);
    setToastMessage("Update successful!");
    setTimeout(() => setShowToast(false), 3000);
    loadData();
  };

  const getAvg = (value) => (value != null ? parseFloat(value).toFixed(1) : "");

  return (
    <div className="card p-3">
      <div className="personal-info-head">
        <h4>Current Average Report</h4>
        <ToastContainer
          style={{ top: "1rem", right: "1rem", position: "fixed" }}
        >
          <Toast
            show={showToast}
            onClose={() => setShowToast(false)}
            autohide
            delay={3000}
          >
            <Toast.Header>
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>

      <h5 className="mb-3">Average GPA (%)</h5>
      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th style={{ width: "150px" }}>Department</th>
            {allLevels.map((lvl) => (
              <th key={lvl}>{lvl}</th>
            ))}
            <th style={{ width: "400px" }}>Overview</th>
          </tr>
        </thead>
        <tbody>
          {allDepartments.map((dept, index) => (
            <tr key={dept}>
              <td>{dept}</td>
              {allLevels.map((lvl) => (
                <td
                  key={lvl}
                  className={getColorClass(data[dept]?.[lvl] ?? 0, "percent")}
                >
                  {getAvg(data[dept]?.[lvl])}
                </td>
              ))}

              {index === 0 && (
                <td
                  rowSpan={allDepartments.length}
                  className={style.overviewCell}
                >
                  <div className="h-100 w-100 d-flex flex-column justify-content-between">
                    {!isStudent ? (
                      <textarea
                        rows={allDepartments.length * 2}
                        className="form-control flex-grow-1"
                        style={{ resize: "none" }}
                        value={overview["caverageTest"] || ""}
                        onChange={(e) => handleOverviewChange(e.target.value)}
                      />
                    ) : (
                      <div className="bg-light border rounded p-2 flex-grow-1 overflow-auto">
                        {overview["caverageTest"]}
                      </div>
                    )}
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      {!isStudent && (
        <div className="text-end">
          <button className="btn btn-primary" onClick={handleUpdate}>
            Update
          </button>
        </div>
      )}
    </div>
  );
}
